
import { ref, toRefs } from 'vue';
import { onClickOutside } from '@/directives/onClickOutside';
import isUrl from '@/utils/url';
import SelectConversation from '@/components/graph/common/SelectConversation';

export default {
  components: { SelectConversation },

  directives: {
    'click-outside': onClickOutside,
  },

  props: {
    disableCurrentConversation: { type: Boolean, default: true },
    disableCurrentAmp: { type: Boolean, default: true },
    onClose: { type: Function, default: () => {} },
    onSelectConversation: { type: Function, default: () => {} },
    selectedAmpId: { type: String, default: '' },
    selectedConversationId: { type: String, default: '' },
    backgroundColor: { type: String, default: '' },
    title: { type: String, default: '' },
    searchThroughEDetails: { type: Boolean, default: false },
    webLink: { type: String, default: '' },
    onChangeWebLink: { type: Function, default: () => {} },
  },

  setup(props) {
    const { webLink } = toRefs(props);

    // Showing webLink tab if the node has that data already
    const tab = ref(webLink.value ? 1 : 0);
    const changes = ref({ webLink: webLink.value });
    const errors = ref({ webLink: '' });

    const changeTab = (newTab) => {
      tab.value = newTab;
    };

    const onInputWebLink = (link) => {
      if (isUrl(link)) {
        errors.value.webLink = '';
        props.onChangeWebLink(link);
      } else {
        errors.value.webLink = 'This should be a valid url.';
      }
    };

    return {
      tab,
      changes,
      errors,
      changeTab,
      onInputWebLink,
    };
  },
};
